import React from 'react'

import Spinner from '../ui/spinner'
import './invoiceMetaCard.scss'

type Props = {
  message: string
  className?: string
}

const InvoiceMetaCardLoading: React.FC<Props> = ({ message, className }) => (
  <div className={['invoice-meta-card', className].filter(Boolean).join(' ')}>
    <div className='invoice-meta-card__loading' role='status'>
      <Spinner />
      <span>{message}</span>
    </div>
  </div>
)

export default InvoiceMetaCardLoading
